module.exports = __webpack_public_path__ + "static/l5-service-card3-081946108f6865b1f01d767b66dcdd2a.svg";